module.exports = __webpack_public_path__ + "static/media/map.537dc070.svg";